@let bundleAvailability = availability();
@let isIncludedInTierBenefits = isBundleAncillariesIncludedInTier();
@let selectedForPax = selectedForPassenger();
@let paxId = passenger().id;
@let tierLvl = tierLevel();
@let overlaps = serviceOverlaps();

<div class="bundle-offer" [attr.data-testid]="'ancillary-bundle-passenger-' + paxId">
  <div class="flex flex--space-between flex--middle ms-small-b">
    <div class="flex flex--middle">
      <h4 #passengerHeading tabindex="-1" class="font-heading-5 font-title-medium nordic-blue-900-text">
        {{ passengerName() }}
      </h4>
      @if (isIncludedInTierBenefits && tierLvl) {
        <fcom-tag class="ms-xsmall-l" data-testid="ancillary-bundle-tier-benefit-badge">
          <fcom-icon [name]="SvgLibraryIcon.FINNAIR_PLUS" class="icon-medium ms-xxsmall-r" />
          <span class="regular-type">{{ tierLvl }}</span>
        </fcom-tag>
      }
    </div>
    @if (!isIncludedInTierBenefits) {
      @if (selectedForPax) {
        <fcom-button
          [attr.data-testid]="'ancillary-bundle-remove-' + paxId"
          [text]="'ancillaries.bundle.toggle.buttonText.removeCombo' | finLocalization"
          [icon]="{ name: SvgLibraryIcon.TRASH, position: IconPosition.LEFT }"
          [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
          (clickBtn)="removeBundle.emit()"
        />
      } @else if (bundleAvailability?.availableInCatalog) {
        <fcom-button
          [attr.data-testid]="'ancillary-bundle-add-' + paxId"
          [text]="'ancillaries.bundle.upsellCard.buttonText.addCombo' | finLocalization"
          [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.LEFT }"
          [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
          [disabled]="overlaps.blockSelections"
          (clickBtn)="addBundle.emit()"
        />
      }
    }
  </div>

  @if (overlaps.showNotification && !isIncludedInTierBenefits && bundleAvailability?.availableInCatalog) {
    <fin-service-overlap-notification
      class="block ms-small-b"
      [category]="category()"
      [overlappingServices]="overlaps.services"
      (continueSelection)="continueToSelection()"
      (cancelSelection)="keepExistingSelection()"
    />
  }

  @if (isIncludedInTierBenefits || bundleAvailability?.availableInCatalog || selectedForPax) {
    <div class="bundle-services flex flex--nowrap" [class.bundle-services--in-cart]="selectedForPax">
      @for (service of constituents(); track service.category; let isLast = $last) {
        <div
          class="bundle-service flex-1 flex--basis0 flex flex--column"
          [attr.data-testid]="'ancillary-bundle-service-' + service.category"
          [class.bundle-service-card--in-cart]="selectedForPax"
          [class.nordic-blue-25-bg]="selectedForPax"
        >
          <fin-bundle-service-card
            [service]="service"
            [inCart]="selectedForPax"
            [isTierBenefit]="isIncludedInTierBenefits"
          />
        </div>

        @if (!isLast) {
          <div class="bundle-services__plus flex flex--center flex--middle ps-small-x">
            <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.PLUS" />
          </div>
        }
      }
      <div class="bundle-offer__price nordic-blue-25-bg rounded-medium flex flex--column flex--center flex--middle">
        @if (isIncludedInTierBenefits) {
          @if (freePrice(); as price) {
            <span
              class="font-heading-5 font-title-small heather-800-text"
              [attr.data-testid]="'ancillary-bundle-price-' + paxId"
              >{{ price | finPrice }}</span
            >
          }
        } @else {
          @if (bundleAvailability?.itemsWithoutBundlePrice; as originalPrice) {
            <span class="strike-through font-body-2" data-testid="ancillary-bundle-original-price">{{
              originalPrice | finPrice
            }}</span>
          }
          <span
            class="font-heading-5 font-title-small heather-800-text"
            [attr.data-testid]="'ancillary-bundle-price-' + paxId"
            >{{ bundleAvailability?.bundleTotalPrice | finPrice }}</span
          >
        }
      </div>
    </div>
  } @else {
    <fcom-notification
      class="block"
      [attr.data-testid]="'ancillary-bundle-unavailable-' + paxId"
      [theme]="NotificationTheme.INFO"
      [scale]="NotificationScale.SMALL"
    >
      <span>{{ 'ancillaries.bundle.unavailableBundle' | finLocalization }}</span>
    </fcom-notification>
  }
</div>
